<template>
  <client-list :table-columns="clientTableColumns">
  </client-list>
</template>
<script>
  import ClientList from 'src/views/admin/contacts/clients/ClientList';
  export default {
    name: 'user-details-logs',
    components: {
      ClientList
    },
    computed: {
      clientTableColumns() {
        return [
          {
            prop: "name",
            label: this.$t('user.list.labels.name'),
            minWidth: "100",
            sortable: true
          }
        ]
      }
    }
  }
</script>
<style>
</style>
